import { http } from "../../../shared/api/http"

/* ===================== TYPES ===================== */

export type UserProfile = {
  email: string
  full_name: string
  phone_number: string
  bio: string
  date_of_birth: string
  city: string
  industry: string
  experience_level: string
  avatar?: {
    original_url: string
    thumb_small_url: string
    thumb_medium_url: string
  }
}

/* ===================== API ===================== */

// Получить мой профиль
export const getMyProfileApi = () => {
  return http.get<UserProfile>("api/users/me/profile")
}

// Обновить мой профиль
export const updateMyProfileApi = (
  data: Partial<UserProfile>
) => {
  return http.patch<UserProfile>("api/users/me/profile", data)
}

export const uploadMyAvatarApi = (file: File) => {
  const formData = new FormData()
  formData.append("file", file)

  return http.post("api/users/me/profile/avatar", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}
